import { IUser } from './user';

export const CLASS_STATUS = {
  Delayed: 'Delayed',
  Dropped: 'Dropped',
  Finished: 'Finished',
  Pending: 'Pending',
  Working: 'Working',
};

export const CLASS_TYPE_CATEGORY = {
  IELTS: 'IELTS',
  ONE_VS_ONE: '1vs1',
  PT: 'PT',
  VSTEP: 'VSTEP',
};

export interface ClassPlaceModel {
  id: number;
  name: string;
  code: string;
  address: string;
}

export interface ClassTypeModel {
  id: number;
  name: string;
  code: string;
  lessonDuration?: number;
  feePay?: number;
  totalLessons: number;
  category?: string;
  description?: string;
  hasFees: boolean;
}

export interface ClassModel {
  id: number;
  name: string;
  aliasName: string;
  lessonDuration: number;
  classTypeId: number;
  classPlaceId: number;
  semester: number;
  status: string;
  schedule: string;
  startDate: Date;
  startTime: Date;
  description: string;
  maxTotalHour?: number;
  classType: ClassTypeModel;
  classPlace: ClassPlaceModel;
}

export interface FullInfoClassModel {
  classData: ClassModel;
  attendanceData: {
    attended: number;
    excused: number;
    absent: number;
    notYetEnrolled: number;
    pending: number;
    totalCompletedLessons: number;
    totalByAttendance: number;
  };
  homeworkData: {
    inProgress: number;
    attend: number;
  };
  exerciseData: {
    inProgress: number;
    attend: number;
  };
  employees: IUser[]; // IUser[]; todo: move to share
}
